import { Injectable } from '@angular/core';
import { HttpClient } from 'src/shared/providers/http/http-client';

import { removeHourAndTimezoneFromDate } from 'src/shared/utils/date-utils';

import { MileageTrackingModel, MileageTrackingRecordModel } from 'src/shared/models/mileage-tracking.model';

@Injectable()
export class MileageTracking {

  constructor(
    private httpClient: HttpClient
  ) {}

  getMileageRecordByDate(startDate: Date | string, endDate: Date | string): Promise<MileageTrackingModel[]> {
    // The API only accepts YYYY-MM-DD; a raw Date interpolates as "Thu Jan 01 2026 00:00:00 GMT-0300 (...)" and gets a 400
    const start = removeHourAndTimezoneFromDate(startDate);
    const end = removeHourAndTimezoneFromDate(endDate);
    const url = `api/v1/homekeeper/mileage-tracking-records/list-by-month?start_date=${start}&end_date=${end}`;
    return this.httpClient.get(url);
  }

  getMileageRecordByHkJob(hKJobId): Promise<MileageTrackingRecordModel[]> {
    const url = `api/v1/homekeeper/mileage-tracking-records?homekeeper_job_id=${hKJobId}`;
    return this.httpClient.get(url);
  }

  getMileageRecordById(mileageTrackingRecordId): Promise<MileageTrackingRecordModel> {
    const url = `api/v1/homekeeper/mileage-tracking-records/${mileageTrackingRecordId}`;
    return this.httpClient.get(url);
  }

  updateMileageTracking(mileageTrackingRecordId, mileage, start, end): Promise<MileageTrackingRecordModel> {
    const data = {
      estimated_mileage: mileage,
      start_location_name: start,
      end_location_name: end
    }
    const url = `api/v1/homekeeper/mileage-tracking-records/${mileageTrackingRecordId}`;
    return this.httpClient.put(url, data);
  }
}
